import React from 'react';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

import 'inventory-listing/components/ListingFilters/Components/ListingFiltersBodyStyle/BodyStyle.scss';

const Bodystyle = ({ bodystyle, handleChange }) => {
    const bodyStyleClasses = ['listing-used-bodystyle'];
    bodyStyleClasses.push(bodystyle.class);

    if (bodystyle.isSelected) {
        bodyStyleClasses.push('selected is-price');
    }

    return (
        <div className={bodyStyleClasses.join(' ')} onClick={() => handleChange(bodystyle.group)}>
            {bodystyle.label}
        </div>
    );
};

Bodystyle.propTypes = {
    bodystyle: React.PropTypes.instanceOf(MetaDataModel),
    handleChange: React.PropTypes.func.isRequired,
};

Bodystyle.displayName = 'Bodystyle';

export default Bodystyle;



// WEBPACK FOOTER //
// ./client/src/components/ListingFilters/Components/ListingFiltersBodyStyle/BodyStyle.jsx